import { Dimensions } from 'react-native';

import Colors from './Colors';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const mobile = 640;
const desktop = 1440;
const tablet = 720;

const isSmall = width <= mobile;
const isMedium = width > mobile && width < desktop;
const isLarge = width >= desktop;
const isCompactScreen = width < tablet;

export default {
  window: {
    width,
    height,
  },
  isSmall,
  isMedium,
  isLarge,
  isCompactScreen,
  mobile,
  usePantryTabs: width < 900, // do we use separate map/list tabs in the pantries view?
  signupContainer: {
    flexGrow: 1,
    justifyContent: isSmall ? 'space-between' : 'flex-start',
    alignItems: 'center',
  },
  formContentContainer: {
    flexGrow: 1,
    backgroundColor: Colors.lightBackground,
    alignItems: 'center',
  },
  formFooter: {
    alignItems: 'center', // Shared: consistent center alignment across all contexts
    flexDirection: 'row',
    height: 'auto', // Shared: flexible height for safe area compatibility
    paddingBottom: 16, // Shared: consistent safe area bottom spacing
    marginTop: 'auto', // Shared: Android 15+ flex positioning for bottom alignment
  },
  get signupFooter() {
    return {
      ...this.formFooter, // Inherits shared positioning principles
      flexDirection: 'column',
      width: 328, // Context-specific: single-button width for signup screens
    };
  },
  topMenuHeight: 65,
  fullWidth: width,
  fullHeight: height,
};
